import React from 'react';
import PublicHeader from '../PublicHeader';
import PublicFooter from '../PublicFooter';
import QuoteRotator from '../QuoteRotator';
import NamedBrands from './components/NamedBrands';
import HotspotRotatorSection from './components/HotspotRotatorSection';
import TestimonialVideo from './components/TestimonialVideo';
import TopSection from './components/TopSection';
import UserUtilityBar from './components/UserUtilityBar';
import {Head} from 'react-static';
import {Col, Row} from 'react-flexa';
import {withStyles} from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Image from '../components/Image';
import Typography from '../components/Typography';
import quotes from './data/quotes.json';
import Hidden from '@material-ui/core/Hidden';
import {imageRoot} from "../../env.config";

const styles = theme => ({
  root: {
    overflow: 'hidden'
  },
  leadBackground: {
    background: `url(${imageRoot}/homepage/directbuy-hero-background.jpg)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  sectionButton: {
    margin: '30px 0 20px',
    maxWidth: 270,
    fontWeight: 'bold',
    alignSelf: 'center',
    padding: '.6rem 1.5rem',
    border: `1.69px solid ${theme.palette.primary.main}`,
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      color: '#fff',
    },
  },
});


class HomePageContainer extends React.Component {

  handleMemberClick = event => {
    event.preventDefault();
    window.location = '/v2/membership-pricing/'
  };

  render() {
    const {classes} = this.props;
    return (
      <div className={classes.root}>
        <Head>
          <title>DirectBuy - Home</title>
          <link rel="stylesheet" type="text/css" charset="UTF-8"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"/>
          <link rel="stylesheet" type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"/>
        </Head>
        <PublicHeader handleClick={this.handleMemberClick}/>
        <div className={classes.leadBackground}>
          <TopSection/>
        </div>
        <NamedBrands otherClasses={{button: classes.sectionButton}}/>
        <TestimonialVideo/>
        <div style={{textAlign: 'center', padding: '3%'}}>
          <Image src="/homepage/consumer affairs.svg" width='162'/>
          <Typography style={{maxWidth: 350, margin: '0 auto'}} variant='body1'>Overall Satisfaction rating based on 767
            ratings submitted in the last year</Typography>
          <Image src="/homepage/consumer-4-stars.svg" width='95'/>
        </div>
        <div style={{padding: '0 20px', margin: '40px 8.333%'}}>
          <QuoteRotator quotes={quotes}/>
        </div>
        <HotspotRotatorSection otherClasses={{button: classes.sectionButton}}/>
        <div style={{textAlign: 'center', paddingTop: 20}}>
          <Typography variant='subtitle2' color='primary'>SIMPLIFYING YOUR SHOPPING EXPERIENCE</Typography>
          <Typography bold={true} variant='h2'>
            We Cut Out The Middleman,<br/>
            So You Can Buy Direct.
          </Typography>
          <Typography variant='body2'>
            When you buy through DirectBuy, you purchase directly through the<br/>
            manufacturer without paying any hidden retail markups.
          </Typography>
          <Row gutter={0}>
            <Col xs={12} sm={12} md={6}>
              <Image src="/homepage/traditional retail experience.svg?10122018"/>
              <Hidden mdUp><Divider variant='fullWidth' style={{margin: '1rem 0'}}/></Hidden>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Image src="/homepage/directbuy_shopping_experience.svg?10122018"/>
            </Col>
          </Row>
        </div>
        <div style={{maxWidth: 1200, margin: '2rem auto', padding: '1rem'}}>
          <Row>
            <Col xs={12} sm={12} md={6}>
              <Image src="/homepage/screen_iphone.jpg" width='100%'/>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Typography variant='h3'>Your Partner for Every Home Project, Big & Small.</Typography>
              <Typography variant='body2'>Looking to upgrade your appliances, take on a major kitchen remodel or find
                quality
                furniture that will last? We’re here to help. Talk to any one of our DirectBuy Service Specialists
                to get started on your next project.
              </Typography>
              <List component="nav">
                <ListItem button component='a' divider={true} href="/services/concierge-services/">
                  <ListItemText primary="CONCIERGE SHOPPING" primaryTypographyProps={{color: 'primary'}}/>
                </ListItem>
                <ListItem button component='a' divider={true} href="/services/design-services/">
                  <ListItemText primary="DESIGNERS" primaryTypographyProps={{color: 'primary'}}/>
                </ListItem>
                <ListItem button component='a' divider={true} href="/services/project-coordination/">
                  <ListItemText primary="PROJECT COORDINATORS" primaryTypographyProps={{color: 'primary'}}/>
                </ListItem>
                <ListItem button component='a' divider={true} href="/services/customer-service/">
                  <ListItemText primary="CUSTOMER SERVICE" primaryTypographyProps={{color: 'primary'}}/>
                </ListItem>
              </List>
            </Col>
          </Row>
        </div>
        <UserUtilityBar/>
        <PublicFooter/>
      </div>
    );
  }
}

export default withStyles(styles)(HomePageContainer)
